export default __webpack_public_path__ + "static/media/Group9181.bc94d379.svg";